// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gm-style-iw-ch {
      padding-top: 0px;
}
.gm-style-iw-t {
      bottom: 75px !important;
}
p.capitalize::first-letter {
      text-transform: capitalize !important;
}
button {
      text-transform: unset !important;
}
.gm-style {
      font: unset !important;
}
.MuiTypography-root {
      letter-spacing: unset !important;
      font-family: "Nunito Sans", sans-serif !important;
}
.wrapper-class {
      padding: 1rem;
      border: 1px solid #ccc;
      margin-top: 10px;
      margin-bottom: 30px;
}

.editor-class {
      background-color: lightgray;
      padding: 1rem;
      border: 1px solid #ccc;
}

.toolbar-class {
      border: 1px solid #ccc;
}

.map-container {
      height: 100%;
      position: relative;
      width: 100%;
}

.map-widget {
      position: absolute;

      background-color: white;
      padding: 10px;
      border-radius: 4px;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}

.map-menu {
      float: right;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
      position: absolute;
      padding: 10px;
      top: 10px;
      right: 10px;
      background-color: white;
      border-radius: 8px;
      cursor: pointer;
      max-width: 366;
}

.map-menu-controls {
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
      position: absolute;
      top: 60px;
      left: 10px;
      background-color: white;
      border-radius: 3px;
      cursor: pointer;
}

.map-button-container {
      position: absolute;
      padding: 10px;
      bottom: 20px; /* Set the distance from the bottom as needed */
      left: 50%;
      transform: translateX(-50%);
      border-radius: 3px;
      cursor: pointer;
}

.gm-style-iw.gm-style-iw-c button.gm-ui-hover-effect {
      display: none !important;
      border: 2px solid grey !important;
      border-radius: 100px !important;
      top: 11px !important;
      right: 16px !important;
      width: 20px !important;
      height: 20px !important;
}
.gm-style-iw.gm-style-iw-c button.gm-ui-hover-effect span {
      width: 16px !important;
      height: 16px !important;
      border: 2px solid grey !important;
      margin: auto !important;
}
.gm-style .gm-style-iw-c {
      /* padding-right: 10px !important;
    padding-bottom: 0px !important;
    max-width: 500px !important;
    max-height: 326px !important;
    min-width: 0px !important; */
      width: 400px !important;
      /* box-sizing: border-box; */
      /* background-color: #eeee; */
      box-shadow: 0 2px 7px 1px rgba(0, 0, 0, 0.3);
      position: absolute;
      /* box-sizing: border-box; */
      overflow: hidden;
      top: 0;
      left: 0;
      transform: translate(-50%, -100%);
      /* background-color: #eeee; */
      border-radius: 8px;
      box-shadow: 0 2px 7px 1px rgba(0, 0, 0, 0.1);
}
@media only screen and (max-width: 1200px) {
      .gm-style .gm-style-iw-c {
            width: 45vw;
      }
}
@media only screen and (max-width: 800px) {
      .gm-style .gm-style-iw-c {
            width: 65vw;
      }
}
@media only screen and (max-width: 600px) {
      .gm-style .gm-style-iw-c {
            width: 80vw;
      }
}
@media only screen and (max-width: 400px) {
      .gm-style .gm-style-iw-c {
            width: 90vw;
            max-width: unset !important;
      }
}

/* .map-menu.open ul {
    display: block;
}

.menu-icon {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
}

.menu-icon span {
    display: block;
    width: 100%;
    height: 2px;
    background-color: #333;
    margin: 2px;
}

ul {
    display: none;
    list-style-type: none;
    padding: 0;
    margin: 0;
}

ul li {
    padding: 5px 0;
    cursor: pointer;
}

ul li:hover {
    background-color: #eee;
} */
.gm-style-iw-d,
.gm-style .gm-style-iw-c {
      overflow: unset !important;
      padding: unset !important;
      max-height: unset !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/wyswyg-editor.css"],"names":[],"mappings":"AAAA;MACM,gBAAgB;AACtB;AACA;MACM,uBAAuB;AAC7B;AACA;MACM,qCAAqC;AAC3C;AACA;MACM,gCAAgC;AACtC;AACA;MACM,sBAAsB;AAC5B;AACA;MACM,gCAAgC;MAChC,iDAAiD;AACvD;AACA;MACM,aAAa;MACb,sBAAsB;MACtB,gBAAgB;MAChB,mBAAmB;AACzB;;AAEA;MACM,2BAA2B;MAC3B,aAAa;MACb,sBAAsB;AAC5B;;AAEA;MACM,sBAAsB;AAC5B;;AAEA;MACM,YAAY;MACZ,kBAAkB;MAClB,WAAW;AACjB;;AAEA;MACM,kBAAkB;;MAElB,uBAAuB;MACvB,aAAa;MACb,kBAAkB;MAClB,wCAAwC;AAC9C;;AAEA;MACM,YAAY;MACZ,wCAAwC;MACxC,kBAAkB;MAClB,aAAa;MACb,SAAS;MACT,WAAW;MACX,uBAAuB;MACvB,kBAAkB;MAClB,eAAe;MACf,cAAc;AACpB;;AAEA;MACM,wCAAwC;MACxC,kBAAkB;MAClB,SAAS;MACT,UAAU;MACV,uBAAuB;MACvB,kBAAkB;MAClB,eAAe;AACrB;;AAEA;MACM,kBAAkB;MAClB,aAAa;MACb,YAAY,EAAE,+CAA+C;MAC7D,SAAS;MACT,2BAA2B;MAC3B,kBAAkB;MAClB,eAAe;AACrB;;AAEA;MACM,wBAAwB;MACxB,iCAAiC;MACjC,+BAA+B;MAC/B,oBAAoB;MACpB,sBAAsB;MACtB,sBAAsB;MACtB,uBAAuB;AAC7B;AACA;MACM,sBAAsB;MACtB,uBAAuB;MACvB,iCAAiC;MACjC,uBAAuB;AAC7B;AACA;MACM;;;;gCAI0B;MAE1B,uBAAuB;MACvB,4BAA4B;MAK5B,6BAA6B;MAE7B,4CAA4C;MAC5C,kBAAkB;MAClB,4BAA4B;MAC5B,gBAAgB;MAChB,MAAM;MACN,OAAO;MACP,iCAAiC;MACjC,6BAA6B;MAC7B,kBAAkB;MAClB,4CAA4C;AAClD;AACA;MACM;YACM,WAAW;MACjB;AACN;AACA;MACM;YACM,WAAW;MACjB;AACN;AACA;MACM;YACM,WAAW;MACjB;AACN;AACA;MACM;YACM,WAAW;YACX,2BAA2B;MACjC;AACN;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAmCG;AACH;;MAEM,0BAA0B;MAC1B,yBAAyB;MACzB,4BAA4B;AAClC","sourcesContent":[".gm-style-iw-ch {\n      padding-top: 0px;\n}\n.gm-style-iw-t {\n      bottom: 75px !important;\n}\np.capitalize::first-letter {\n      text-transform: capitalize !important;\n}\nbutton {\n      text-transform: unset !important;\n}\n.gm-style {\n      font: unset !important;\n}\n.MuiTypography-root {\n      letter-spacing: unset !important;\n      font-family: \"Nunito Sans\", sans-serif !important;\n}\n.wrapper-class {\n      padding: 1rem;\n      border: 1px solid #ccc;\n      margin-top: 10px;\n      margin-bottom: 30px;\n}\n\n.editor-class {\n      background-color: lightgray;\n      padding: 1rem;\n      border: 1px solid #ccc;\n}\n\n.toolbar-class {\n      border: 1px solid #ccc;\n}\n\n.map-container {\n      height: 100%;\n      position: relative;\n      width: 100%;\n}\n\n.map-widget {\n      position: absolute;\n\n      background-color: white;\n      padding: 10px;\n      border-radius: 4px;\n      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n}\n\n.map-menu {\n      float: right;\n      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n      position: absolute;\n      padding: 10px;\n      top: 10px;\n      right: 10px;\n      background-color: white;\n      border-radius: 8px;\n      cursor: pointer;\n      max-width: 366;\n}\n\n.map-menu-controls {\n      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n      position: absolute;\n      top: 60px;\n      left: 10px;\n      background-color: white;\n      border-radius: 3px;\n      cursor: pointer;\n}\n\n.map-button-container {\n      position: absolute;\n      padding: 10px;\n      bottom: 20px; /* Set the distance from the bottom as needed */\n      left: 50%;\n      transform: translateX(-50%);\n      border-radius: 3px;\n      cursor: pointer;\n}\n\n.gm-style-iw.gm-style-iw-c button.gm-ui-hover-effect {\n      display: none !important;\n      border: 2px solid grey !important;\n      border-radius: 100px !important;\n      top: 11px !important;\n      right: 16px !important;\n      width: 20px !important;\n      height: 20px !important;\n}\n.gm-style-iw.gm-style-iw-c button.gm-ui-hover-effect span {\n      width: 16px !important;\n      height: 16px !important;\n      border: 2px solid grey !important;\n      margin: auto !important;\n}\n.gm-style .gm-style-iw-c {\n      /* padding-right: 10px !important;\n    padding-bottom: 0px !important;\n    max-width: 500px !important;\n    max-height: 326px !important;\n    min-width: 0px !important; */\n      position: absolute;\n      width: 400px !important;\n      /* box-sizing: border-box; */\n      overflow: hidden;\n      top: 0;\n      left: 0;\n      transform: translate(-50%, -100%);\n      /* background-color: #eeee; */\n      border-radius: 8px;\n      box-shadow: 0 2px 7px 1px rgba(0, 0, 0, 0.3);\n      position: absolute;\n      /* box-sizing: border-box; */\n      overflow: hidden;\n      top: 0;\n      left: 0;\n      transform: translate(-50%, -100%);\n      /* background-color: #eeee; */\n      border-radius: 8px;\n      box-shadow: 0 2px 7px 1px rgba(0, 0, 0, 0.1);\n}\n@media only screen and (max-width: 1200px) {\n      .gm-style .gm-style-iw-c {\n            width: 45vw;\n      }\n}\n@media only screen and (max-width: 800px) {\n      .gm-style .gm-style-iw-c {\n            width: 65vw;\n      }\n}\n@media only screen and (max-width: 600px) {\n      .gm-style .gm-style-iw-c {\n            width: 80vw;\n      }\n}\n@media only screen and (max-width: 400px) {\n      .gm-style .gm-style-iw-c {\n            width: 90vw;\n            max-width: unset !important;\n      }\n}\n\n/* .map-menu.open ul {\n    display: block;\n}\n\n.menu-icon {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 20px;\n    height: 20px;\n}\n\n.menu-icon span {\n    display: block;\n    width: 100%;\n    height: 2px;\n    background-color: #333;\n    margin: 2px;\n}\n\nul {\n    display: none;\n    list-style-type: none;\n    padding: 0;\n    margin: 0;\n}\n\nul li {\n    padding: 5px 0;\n    cursor: pointer;\n}\n\nul li:hover {\n    background-color: #eee;\n} */\n.gm-style-iw-d,\n.gm-style .gm-style-iw-c {\n      overflow: unset !important;\n      padding: unset !important;\n      max-height: unset !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
